

const Btn = ({ innerText, bg }) => {
    return (
        <button className={`mt-5 md:mt-0 w-full md:w-52 h-12 rounded-3xl text-white font-Lato font-bold ${bg}`}>{innerText}</button>
    )
}

export default Btn